import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_ORDERS_SHIPPED_BACK_TO_CHINA } from "/@/gql/orders";

interface OrderShippedBack {
  id: string;
  orderReference: string;
  shippedBackToProviderDate: string;
}

const BackToChinaList = () => {
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [orders, setOrders] = useState<OrderShippedBack[]>([]);

  const startOfDay = new Date(selectedDate);
  startOfDay.setHours(0, 0, 0, 0);

  const endOfDay = new Date(selectedDate);
  endOfDay.setHours(23, 59, 59, 999);

  const { data, loading } = useQuery(GET_ORDERS_SHIPPED_BACK_TO_CHINA, {
    variables: {
      where: {
        shippedBackToProviderDate: {
          gte: startOfDay.toISOString(),
          lte: endOfDay.toISOString(),
        },
      },
    },
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (data?.getAllOrdersForStaff?.orders) {
      setOrders(data.getAllOrdersForStaff.orders);
    }
  }, [data]);

  if (loading) {
    return <>Loading...</>;
  }

  return (
    <>
      <input
        type="date"
        value={selectedDate.toISOString().split("T")[0]}
        style={{ margin: "1rem" }}
        onChange={e => {
          if (!e.target.value) {
            return;
          }
          setSelectedDate(new Date(e.target.value));
        }}
      />
      {orders.length === 0 ? (
        <div>
          No orders shipped back to China on {selectedDate.toLocaleDateString()}
        </div>
      ) : (
        <div style={{ padding: "1rem" }}>
          <ul style={{ listStyleType: "disc", paddingLeft: "2rem" }}>
            {orders.map(order => (
              <li key={order.id} style={{ marginBottom: "0.5rem" }}>
                {order.orderReference}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default BackToChinaList;
